import { NgStyle, NgClass, NgTemplateOutlet } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, ChangeDetectionStrategy, NgModule, Injectable } from '@angular/core';
import { notificationMotion } from 'ng-zorro-antd/core/animation';
import * as i2 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import * as i1 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMNComponent, NzMNContainerComponent, NzMNService } from 'ng-zorro-antd/message';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { toCssPixel } from 'ng-zorro-antd/core/util';
import * as i1$1 from 'ng-zorro-antd/core/config';
import * as i1$2 from 'ng-zorro-antd/core/services';
import * as i2$1 from '@angular/cdk/overlay';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
const _c0 = (a0, a1) => ({
  $implicit: a0,
  data: a1
});
const _c1 = a0 => ({
  $implicit: a0
});
function NzNotificationComponent_Conditional_1_ng_template_0_Template(rf, ctx) {}
function NzNotificationComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzNotificationComponent_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.instance.template)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c0, ctx_r0, ctx_r0.instance.options == null ? null : ctx_r0.instance.options.nzData));
  }
}
function NzNotificationComponent_Conditional_2_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
  }
}
function NzNotificationComponent_Conditional_2_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
}
function NzNotificationComponent_Conditional_2_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 11);
  }
}
function NzNotificationComponent_Conditional_2_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
  }
}
function NzNotificationComponent_Conditional_2_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.instance.title, i0.ɵɵsanitizeHtml);
  }
}
function NzNotificationComponent_Conditional_2_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.instance.content, i0.ɵɵsanitizeHtml);
  }
}
function NzNotificationComponent_Conditional_2_Conditional_11_ng_template_1_Template(rf, ctx) {}
function NzNotificationComponent_Conditional_2_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtemplate(1, NzNotificationComponent_Conditional_2_Conditional_11_ng_template_1_Template, 0, 0, "ng-template", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, ctx_r0));
  }
}
function NzNotificationComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 4)(2, "div");
    i0.ɵɵtemplate(3, NzNotificationComponent_Conditional_2_Case_3_Template, 1, 0)(4, NzNotificationComponent_Conditional_2_Case_4_Template, 1, 0)(5, NzNotificationComponent_Conditional_2_Case_5_Template, 1, 0)(6, NzNotificationComponent_Conditional_2_Case_6_Template, 1, 0);
    i0.ɵɵelementStart(7, "div", 5);
    i0.ɵɵtemplate(8, NzNotificationComponent_Conditional_2_ng_container_8_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵtemplate(10, NzNotificationComponent_Conditional_2_ng_container_10_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, NzNotificationComponent_Conditional_2_Conditional_11_Template, 2, 4, "span", 8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_5_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("ant-notification-notice-with-icon", ctx_r0.instance.type !== "blank");
    i0.ɵɵadvance();
    i0.ɵɵconditional(3, (tmp_2_0 = ctx_r0.instance.type) === "success" ? 3 : tmp_2_0 === "info" ? 4 : tmp_2_0 === "warning" ? 5 : tmp_2_0 === "error" ? 6 : -1);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.instance.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.instance.content);
    i0.ɵɵadvance();
    i0.ɵɵconditional(11, (tmp_5_0 = ctx_r0.instance.options == null ? null : ctx_r0.instance.options.nzButton) ? 11 : -1, tmp_5_0);
  }
}
function NzNotificationComponent_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const closeIcon_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzType", closeIcon_r2);
  }
}
function NzNotificationComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzNotificationComponent_Conditional_5_ng_container_0_Template, 2, 1, "ng-container", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.instance.options == null ? null : ctx_r0.instance.options.nzCloseIcon);
  }
}
function NzNotificationComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 15);
  }
}
function NzNotificationContainerComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-notification", 7);
    i0.ɵɵlistener("destroyed", function NzNotificationContainerComponent_For_2_Template_nz_notification_destroyed_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.remove($event.id, $event.userAction));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const instance_r3 = ctx.$implicit;
    i0.ɵɵproperty("instance", instance_r3)("placement", "topLeft");
  }
}
function NzNotificationContainerComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-notification", 7);
    i0.ɵɵlistener("destroyed", function NzNotificationContainerComponent_For_5_Template_nz_notification_destroyed_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.remove($event.id, $event.userAction));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const instance_r5 = ctx.$implicit;
    i0.ɵɵproperty("instance", instance_r5)("placement", "topRight");
  }
}
function NzNotificationContainerComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-notification", 7);
    i0.ɵɵlistener("destroyed", function NzNotificationContainerComponent_For_8_Template_nz_notification_destroyed_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.remove($event.id, $event.userAction));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const instance_r7 = ctx.$implicit;
    i0.ɵɵproperty("instance", instance_r7)("placement", "bottomLeft");
  }
}
function NzNotificationContainerComponent_For_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-notification", 7);
    i0.ɵɵlistener("destroyed", function NzNotificationContainerComponent_For_11_Template_nz_notification_destroyed_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.remove($event.id, $event.userAction));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const instance_r9 = ctx.$implicit;
    i0.ɵɵproperty("instance", instance_r9)("placement", "bottomRight");
  }
}
function NzNotificationContainerComponent_For_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-notification", 7);
    i0.ɵɵlistener("destroyed", function NzNotificationContainerComponent_For_14_Template_nz_notification_destroyed_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.remove($event.id, $event.userAction));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const instance_r11 = ctx.$implicit;
    i0.ɵɵproperty("instance", instance_r11)("placement", "top");
  }
}
function NzNotificationContainerComponent_For_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-notification", 7);
    i0.ɵɵlistener("destroyed", function NzNotificationContainerComponent_For_17_Template_nz_notification_destroyed_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.remove($event.id, $event.userAction));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const instance_r13 = ctx.$implicit;
    i0.ɵɵproperty("instance", instance_r13)("placement", "bottom");
  }
}
let NzNotificationComponent = /*#__PURE__*/(() => {
  class NzNotificationComponent extends NzMNComponent {
    constructor(cdr) {
      super(cdr);
      this.destroyed = new EventEmitter();
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      this.instance.onClick.complete();
    }
    onClick(event) {
      this.instance.onClick.next(event);
    }
    close() {
      this.destroy(true);
    }
    get state() {
      if (this.instance.state === 'enter') {
        switch (this.placement) {
          case 'topLeft':
          case 'bottomLeft':
            return 'enterLeft';
          case 'topRight':
          case 'bottomRight':
            return 'enterRight';
          case 'top':
            return 'enterTop';
          case 'bottom':
            return 'enterBottom';
          default:
            return 'enterRight';
        }
      } else {
        return this.instance.state;
      }
    }
    static {
      this.ɵfac = function NzNotificationComponent_Factory(t) {
        return new (t || NzNotificationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzNotificationComponent,
        selectors: [["nz-notification"]],
        inputs: {
          instance: "instance",
          index: "index",
          placement: "placement"
        },
        outputs: {
          destroyed: "destroyed"
        },
        exportAs: ["nzNotification"],
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 7,
        vars: 5,
        consts: [[1, "ant-notification-notice", "ant-notification-notice-closable", 3, "click", "mouseenter", "mouseleave", "ngStyle", "ngClass"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["tabindex", "0", 1, "ant-notification-notice-close", 3, "click"], [1, "ant-notification-notice-close-x"], [1, "ant-notification-notice-content"], [1, "ant-notification-notice-message"], [4, "nzStringTemplateOutlet"], [1, "ant-notification-notice-description"], [1, "ant-notification-notice-btn"], ["nz-icon", "", "nzType", "check-circle", 1, "ant-notification-notice-icon", "ant-notification-notice-icon-success"], ["nz-icon", "", "nzType", "info-circle", 1, "ant-notification-notice-icon", "ant-notification-notice-icon-info"], ["nz-icon", "", "nzType", "exclamation-circle", 1, "ant-notification-notice-icon", "ant-notification-notice-icon-warning"], ["nz-icon", "", "nzType", "close-circle", 1, "ant-notification-notice-icon", "ant-notification-notice-icon-error"], [3, "innerHTML"], ["nz-icon", "", 3, "nzType"], ["nz-icon", "", "nzType", "close", 1, "ant-notification-close-icon"]],
        template: function NzNotificationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("@notificationMotion.done", function NzNotificationComponent_Template_div_animation_notificationMotion_done_0_listener($event) {
              return ctx.animationStateChanged.next($event);
            })("click", function NzNotificationComponent_Template_div_click_0_listener($event) {
              return ctx.onClick($event);
            })("mouseenter", function NzNotificationComponent_Template_div_mouseenter_0_listener() {
              return ctx.onEnter();
            })("mouseleave", function NzNotificationComponent_Template_div_mouseleave_0_listener() {
              return ctx.onLeave();
            });
            i0.ɵɵtemplate(1, NzNotificationComponent_Conditional_1_Template, 1, 5, null, 1)(2, NzNotificationComponent_Conditional_2_Template, 12, 6);
            i0.ɵɵelementStart(3, "a", 2);
            i0.ɵɵlistener("click", function NzNotificationComponent_Template_a_click_3_listener() {
              return ctx.close();
            });
            i0.ɵɵelementStart(4, "span", 3);
            i0.ɵɵtemplate(5, NzNotificationComponent_Conditional_5_Template, 1, 1, "ng-container")(6, NzNotificationComponent_Conditional_6_Template, 1, 0);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", (ctx.instance.options == null ? null : ctx.instance.options.nzStyle) || null)("ngClass", (ctx.instance.options == null ? null : ctx.instance.options.nzClass) || "")("@notificationMotion", ctx.state);
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.instance.template ? 1 : 2);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(5, (ctx.instance.options == null ? null : ctx.instance.options.nzCloseIcon) ? 5 : 6);
          }
        },
        dependencies: [NgStyle, NgClass, NzIconModule, i1.NzIconDirective, NzOutletModule, i2.NzStringTemplateOutletDirective, NgTemplateOutlet],
        encapsulation: 2,
        data: {
          animation: [notificationMotion]
        }
      });
    }
  }
  return NzNotificationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NZ_CONFIG_MODULE_NAME = 'notification';
const NZ_NOTIFICATION_DEFAULT_CONFIG = {
  nzTop: '24px',
  nzBottom: '24px',
  nzPlacement: 'topRight',
  nzDuration: 4500,
  nzMaxStack: 8,
  nzPauseOnHover: true,
  nzAnimate: true,
  nzDirection: 'ltr'
};
let NzNotificationContainerComponent = /*#__PURE__*/(() => {
  class NzNotificationContainerComponent extends NzMNContainerComponent {
    constructor(cdr, nzConfigService) {
      super(cdr, nzConfigService);
      this.dir = 'ltr';
      this.instances = [];
      this.topLeftInstances = [];
      this.topRightInstances = [];
      this.bottomLeftInstances = [];
      this.bottomRightInstances = [];
      this.topInstances = [];
      this.bottomInstances = [];
      const config = this.nzConfigService.getConfigForComponent(NZ_CONFIG_MODULE_NAME);
      this.dir = config?.nzDirection || 'ltr';
    }
    create(notification) {
      const noti = this.onCreate(notification);
      const key = noti.options.nzKey;
      const notificationWithSameKey = this.instances.find(msg => msg.options.nzKey === notification.options.nzKey);
      if (key && notificationWithSameKey) {
        this.replaceNotification(notificationWithSameKey, noti);
      } else {
        if (this.instances.length >= this.config.nzMaxStack) {
          this.instances = this.instances.slice(1);
        }
        this.instances = [...this.instances, noti];
      }
      this.readyInstances();
      return noti;
    }
    onCreate(instance) {
      instance.options = this.mergeOptions(instance.options);
      instance.onClose = new Subject();
      instance.onClick = new Subject();
      return instance;
    }
    subscribeConfigChange() {
      this.nzConfigService.getConfigChangeEventForComponent(NZ_CONFIG_MODULE_NAME).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateConfig();
        const config = this.nzConfigService.getConfigForComponent(NZ_CONFIG_MODULE_NAME);
        if (config) {
          const {
            nzDirection
          } = config;
          this.dir = nzDirection || this.dir;
        }
      });
    }
    updateConfig() {
      this.config = {
        ...NZ_NOTIFICATION_DEFAULT_CONFIG,
        ...this.config,
        ...this.nzConfigService.getConfigForComponent(NZ_CONFIG_MODULE_NAME)
      };
      this.top = toCssPixel(this.config.nzTop);
      this.bottom = toCssPixel(this.config.nzBottom);
      this.cdr.markForCheck();
    }
    replaceNotification(old, _new) {
      old.title = _new.title;
      old.content = _new.content;
      old.template = _new.template;
      old.type = _new.type;
      old.options = _new.options;
    }
    readyInstances() {
      const instancesMap = {
        topLeft: [],
        topRight: [],
        bottomLeft: [],
        bottomRight: [],
        top: [],
        bottom: []
      };
      this.instances.forEach(m => {
        const placement = m.options.nzPlacement;
        switch (placement) {
          case 'topLeft':
            instancesMap.topLeft.unshift(m);
            break;
          case 'topRight':
            instancesMap.topRight.unshift(m);
            break;
          case 'bottomLeft':
            instancesMap.bottomLeft.unshift(m);
            break;
          case 'bottomRight':
            instancesMap.bottomRight.unshift(m);
            break;
          case 'top':
            instancesMap.top.unshift(m);
            break;
          case 'bottom':
            instancesMap.bottom.unshift(m);
            break;
          default:
            instancesMap.topRight.unshift(m);
        }
      });
      this.topLeftInstances = instancesMap.topLeft;
      this.topRightInstances = instancesMap.topRight;
      this.bottomLeftInstances = instancesMap.bottomLeft;
      this.bottomRightInstances = instancesMap.bottomRight;
      this.topInstances = instancesMap.top;
      this.bottomInstances = instancesMap.bottom;
      this.cdr.detectChanges();
    }
    mergeOptions(options) {
      const {
        nzDuration,
        nzAnimate,
        nzPauseOnHover,
        nzPlacement
      } = this.config;
      return {
        nzDuration,
        nzAnimate,
        nzPauseOnHover,
        nzPlacement,
        ...options
      };
    }
    static {
      this.ɵfac = function NzNotificationContainerComponent_Factory(t) {
        return new (t || NzNotificationContainerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.NzConfigService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzNotificationContainerComponent,
        selectors: [["nz-notification-container"]],
        exportAs: ["nzNotificationContainer"],
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 18,
        vars: 40,
        consts: [[1, "ant-notification", "ant-notification-topLeft"], [3, "instance", "placement"], [1, "ant-notification", "ant-notification-topRight"], [1, "ant-notification", "ant-notification-bottomLeft"], [1, "ant-notification", "ant-notification-bottomRight"], [1, "ant-notification", "ant-notification-top"], [1, "ant-notification", "ant-notification-bottom"], [3, "destroyed", "instance", "placement"]],
        template: function NzNotificationContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, NzNotificationContainerComponent_For_2_Template, 1, 2, "nz-notification", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵrepeaterCreate(4, NzNotificationContainerComponent_For_5_Template, 1, 2, "nz-notification", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 3);
            i0.ɵɵrepeaterCreate(7, NzNotificationContainerComponent_For_8_Template, 1, 2, "nz-notification", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 4);
            i0.ɵɵrepeaterCreate(10, NzNotificationContainerComponent_For_11_Template, 1, 2, "nz-notification", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 5);
            i0.ɵɵrepeaterCreate(13, NzNotificationContainerComponent_For_14_Template, 1, 2, "nz-notification", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "div", 6);
            i0.ɵɵrepeaterCreate(16, NzNotificationContainerComponent_For_17_Template, 1, 2, "nz-notification", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("top", ctx.top)("left", "0px");
            i0.ɵɵclassProp("ant-notification-rtl", ctx.dir === "rtl");
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.topLeftInstances);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("top", ctx.top)("right", "0px");
            i0.ɵɵclassProp("ant-notification-rtl", ctx.dir === "rtl");
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.topRightInstances);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("bottom", ctx.bottom)("left", "0px");
            i0.ɵɵclassProp("ant-notification-rtl", ctx.dir === "rtl");
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.bottomLeftInstances);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("bottom", ctx.bottom)("right", "0px");
            i0.ɵɵclassProp("ant-notification-rtl", ctx.dir === "rtl");
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.bottomRightInstances);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("top", ctx.top)("left", "50%")("transform", "translateX(-50%)");
            i0.ɵɵclassProp("ant-notification-rtl", ctx.dir === "rtl");
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.topInstances);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("bottom", ctx.bottom)("left", "50%")("transform", "translateX(-50%)");
            i0.ɵɵclassProp("ant-notification-rtl", ctx.dir === "rtl");
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.bottomInstances);
          }
        },
        dependencies: [NzNotificationComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NzNotificationContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzNotificationModule = /*#__PURE__*/(() => {
  class NzNotificationModule {
    static {
      this.ɵfac = function NzNotificationModule_Factory(t) {
        return new (t || NzNotificationModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzNotificationModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzNotificationComponent, NzNotificationContainerComponent]
      });
    }
  }
  return NzNotificationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

let notificationId = 0;
let NzNotificationService = /*#__PURE__*/(() => {
  class NzNotificationService extends NzMNService {
    constructor(nzSingletonService, overlay, injector) {
      super(nzSingletonService, overlay, injector);
      this.componentPrefix = 'notification-';
    }
    success(title, content, options) {
      return this.create('success', title, content, options);
    }
    error(title, content, options) {
      return this.create('error', title, content, options);
    }
    info(title, content, options) {
      return this.create('info', title, content, options);
    }
    warning(title, content, options) {
      return this.create('warning', title, content, options);
    }
    blank(title, content, options) {
      return this.create('blank', title, content, options);
    }
    create(type, title, content, options) {
      return this.createInstance({
        type,
        title,
        content
      }, options);
    }
    template(template, options) {
      return this.createInstance({
        template
      }, options);
    }
    generateMessageId() {
      return `${this.componentPrefix}-${notificationId++}`;
    }
    createInstance(message, options) {
      this.container = this.withContainer(NzNotificationContainerComponent);
      return this.container.create({
        ...message,
        ...{
          createdAt: new Date(),
          messageId: options?.nzKey || this.generateMessageId(),
          options
        }
      });
    }
    static {
      this.ɵfac = function NzNotificationService_Factory(t) {
        return new (t || NzNotificationService)(i0.ɵɵinject(i1$2.NzSingletonService), i0.ɵɵinject(i2$1.Overlay), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NzNotificationService,
        factory: NzNotificationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NzNotificationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzNotificationServiceModule = /*#__PURE__*/(() => {
  class NzNotificationServiceModule {
    static {
      this.ɵfac = function NzNotificationServiceModule_Factory(t) {
        return new (t || NzNotificationServiceModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzNotificationServiceModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return NzNotificationServiceModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzNotificationComponent, NzNotificationContainerComponent, NzNotificationModule, NzNotificationService, NzNotificationServiceModule };
